import { defineMessages } from 'react-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionCompact: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionWide: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ctaButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'post-office.rovo-extension-install-cta-rovo-chat-input.banner-title',
		defaultMessage: 'Use Rovo everywhere',
		description: 'Title for the Rovo extension install CTA banner',
	},
	descriptionCompact: {
		id: 'post-office.rovo-extension-install-cta-rovo-chat-input.banner-description-compact',
		defaultMessage:
			'Install the Chrome extension for instant, trusted answers anywhere you browse.',
		description:
			'Description text for the compact (vertical) variant of the Rovo extension install CTA',
	},
	descriptionWide: {
		id: 'post-office.rovo-extension-install-cta-rovo-chat-input.banner-description-wide',
		defaultMessage:
			'Download the Chrome extension to use Rovo in your browser. Get instant answers from trusted sources',
		description:
			'Description text for the wide (horizontal) variant of the Rovo extension install CTA',
	},
	ctaButton: {
		id: 'post-office.rovo-extension-install-cta-rovo-chat-input.banner-cta-button',
		defaultMessage: 'Get extension',
		description: 'Button text to download the Rovo Chrome extension',
	},
	dismissButtonLabel: {
		id: 'post-office.rovo-extension-install-cta-rovo-chat-input.banner-dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Accessibility label for the dismiss button',
	},
});
